import styled from "styled-components"
// import { device } from "breakpoints"

export const HomeTemplateContainer = styled.div``
